import type * as Highcharts from 'highcharts'

import type { CostCategory } from '@/types/vehicleAnalytics'

export const CATEGORY_COLORS: Record<CostCategory, string> = {
  advance: '#5DBFFF',
  paidRoads: '#A8ABFF',
  fuel: '#FF9A00',
}

export function chartTheme(isDark: boolean) {
  const textColor = isDark ? '#e4e4e7' : '#27272a'
  const lineColor = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'
  const gridLineColor = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'

  const base: Highcharts.Options = {
    chart: {
      backgroundColor: 'transparent',
      style: { fontFamily: 'inherit' },
    },
    title: { text: '' },
    credits: { enabled: false },
    accessibility: { enabled: false },
    legend: {
      itemStyle: { color: textColor, fontWeight: 'normal' },
      itemHoverStyle: { color: isDark ? '#ffffff' : '#000000' },
    },
  }

  return { textColor, lineColor, gridLineColor, base }
}
